import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import MonthSlider from '../MonthSlider';
import classNames from 'classnames';
const SchoolCard = (props) => {
  return (
    <div className="schoolcard">
      <div className="row">
        <div className="col">
          <div className="schoolcard__image">
            <LazyLoadImage effect="blur" src={props.image} alt={props.imageAlt} />
          </div>
        </div>
        <div className="col">
          <div className="schoolcard__content">
            <h2>
              {props.header}
              <br />PRICE: {props.price}
            </h2>
            <h3 className="schoolcard__subheader">{props.subheader}</h3>
            <p>{props.text}</p>
            <span className={classNames("note",props.noteClassName)}>{props.note}</span>
            {props.url && (
							<a
								href={props.url ? props.url : "https://pds.eventsbmw.com/"}
								target="_blank"
								rel="noopener noreferrer"
							>
								<button className="btn btn-blue">Book Now</button>
							</a>
						)}
						{props.monthSlider && (
							<MonthSlider
								monthSliderHeader={props.monthSliderHeader}
								backgroundColor="#E5E5E5"
                urlQuery={props.monthSliderQuery || "&class=BMW_One_Day_School"}
							/>
						)}
          </div>
        </div>
      </div>
    </div>
  );
};
export default SchoolCard;
